<template>
  <ContextMenu ref="contextMenu" :nodeClicked="nodeClicked" :nodesSaved="nodesSaved">
    <Canvas @hideContextMenu="testeventCore()" @canvasClicked="testCanvasClicked()"/>
  </ContextMenu>
</template>

<script>
import ContextMenu from "../components/Core/ContextMenu";
import Canvas from "../components/Core/Canvas";
import { mapActions } from "vuex";

export default {
  name: "home",
  data() {
    return {
      nodeClicked : true,
      nodesSaved: [],
    }
  },
  components: {
    ContextMenu,
    Canvas,
  },

  beforeMount() {
    // Check if the project id is not null

    this.currentProject = this.$route.params.id;
    // this.$http.get(`/projects/${this.$route.params.id}/skills/`).then(({ data }) => {
    //   this.skillId = data[0]._id;
    //   this.$router.push({
    //     path: `/projects/5f9934dea25c715d7f9a663c/skills/${this.skillId}`,
    //   });
    // });

    this.breadcrumbs = [
      {
        text: "Projects",
        disabled: false,
        to: "/projects",
        link: true,
        exact: true,
      },
      {
        text: this.$route.params.id,
        disabled: false,
        to: `/projects/${this.$route.params.id}`,
        link: true,
        exact: true,
      },
      {
        text: "Skills",
        disabled: false,
        to: `/projects/${this.$route.params.id}/skills`,
        link: true,
        exact: true,
      },
      {
        text: this.skillId,
        disabled: true,
      },
    ];
  },
  mounted() {
    this.getSkills({projectId: this.currentProject})
        .then((project) => {
          project.map((skill) => {
            this.getSavedNodes(skill._id)
              .then((savedNodes) => {
                const promises = savedNodes.map(node => {
                  if (node) {
                    console.log(node);
                    this.nodesSaved.push(            
                      {
                        title: node.name,
                        icon: "mdi-plus",
                        action: node,          
                      }
                    );
                  }
                })
                return Promise.all(promises);
              })
              .catch((err) => {
                console.log(err.message);
              })
          });
        })
        .catch((err) => {
            console.log(err.message);
        });
  },
  methods: {
    ...mapActions({
      getSavedNodes: "http/nodes/getSavedNodes",
      getSkills: "http/skills/get",
    }),
    testeventCore() {
      this.nodeClicked = false;
    },
    testCanvasClicked() {
      if(!this.nodeClicked){
        this.nodeClicked = true;
      }
    }
  }
};
</script>

<style>
main {
  height: 100vh !important;
  max-height: 100vh !important;
}
</style>
